import { Component } from '@angular/core';
import { GoodsComponent } from './goods.component';
import { SectionComponent } from './section.component';
import { PageComponent } from './page.component';

/**
 * コマ
 *
 * @export
 * @class KomaComponent
 */
@Component({
  selector: 'app-koma',
  template: '',
})

export class KomaComponent {

  public komaData: any = null;
  // コマID
  public komaId = String('');
  /** X位置(mm) */
  public positionX: number = null;
  /** Y位置(mm) */
  public positionY: number = null;
  /** 幅(mm) */
  public sizeW: number = null;
  /** 高さ(mm) */
  public sizeH: number = null;
  // プロモーション名
  public promotionName = String('');
  // 掲載料請求枠数
  public publishAmountLimitNum: number = null;

  // 選択状態
  public selected: boolean = null;

  public goods: GoodsComponent = new GoodsComponent();

  public page: PageComponent = null;
  public section: SectionComponent = null;

  // 追加するコマ情報
  public drawKomaSizeW = 0;
  public drawKomaSizeH = 0;
  public drawKomaPositionX = 0;
  public drawKomaPositionY = 0;

  /**
   *Creates an instance of KomaComponent.
   * @memberof KomaComponent
   */
  constructor(
  ) {
  }

  /**
   * コマ情報設定
   *
   * @param {*} komaData
   * @memberof KomaComponent
   */
  public setData(komaData: any): void {
    // 初期化
    this.clear();

    // コマ情報設定
    this.komaData = komaData;
    this.komaId = komaData.KomaID;
    this.positionX = parseFloat(komaData.PositionX);
    this.positionY = parseFloat(komaData.PositionY);
    this.sizeW = parseFloat(komaData.SizeW);
    this.sizeH = parseFloat(komaData.SizeH);
    if (komaData.PromotionName != null) {
      this.promotionName = komaData.PromotionName;
    } else {
      this.promotionName = '';
    }

    // 商品情報設定
    this.goods = new GoodsComponent();
    this.goods.setData(komaData.LayoutInfo, komaData.ImageInfo, this.promotionName);
  }

  /**
   * コマ情報更新
   *
   * @param {*} komaData
   * @memberof KomaComponent
   */
  updateKomaData(komaData: any) {
    this.positionX = komaData.positionX;
    this.positionY = komaData.positionY;
    this.sizeW = komaData.sizeW;
    this.sizeH = komaData.sizeH;
  }

  /**
   * ページ情報をクリアする
   *
   * @memberof KomaComponent
   */
  public clear(): void {
    this.sizeW = 0;
    this.sizeH = 0;
  }

  /**
   * コマ配置商品PCODEリストを取得する
   *
   * @returns {Array<string>} PCodeリスト
   * @memberof KomaComponent
   */
  public getPcodeList(): Array<string> {
    return this.goods.pcodeList;
  }

  /**
   * 商品リスト情報を取得する※実績履歴用
   *
   * @returns {Array<any>} 商品のリスト
   * @memberof KomaComponent
   */
  public getGoodsList(): Array<any> {
    return this.goods.getGoodsList();
  }

  /**
   * Pコードが存在するかチェックを行う
   *
   * @param {string} pcode Pコード
   * @returns {boolean}
   * @memberof KomaComponent
   */
  public hasPcode(pcode: string): boolean {
    for (let i = Number(0); i < this.goods.pcodeList.length; i++) {
      if (pcode === this.goods.pcodeList[i]) {
        return true;
      }
    }
    return false;
  }

}
